module.exports = __webpack_public_path__ + "img/Nudes.37a76000.webp";